module.exports = __webpack_public_path__ + "img/slash-primary.acefe2cf.svg";